// src/utils/auth.js - Auth utilities
export const getToken = () => localStorage.getItem('token');
export const getUser = () => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};
export const setAuth = (token, user) => {
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
};
export const clearAuth = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};
export const isAuthenticated = () => !!getToken();
export const isAdmin = () => {
  const user = getUser();
  return user?.role === 'admin';
};
export const isJournalist = () => {
  const user = getUser();
  return user?.role === 'journalist';
};

